import React, { Component, Suspense } from "react";

import Navbar from "../component/Navbar/NavBar";

import Section from "../component/Section";
import Overview from "../component/Overview/Overview";
import { lazyWithRetry } from "../utils/lazyWithRetry";

const Courses = lazyWithRetry(() => import("../component/Courses"));
const Services = lazyWithRetry(() => import("../component/Services"));
const Products = lazyWithRetry(() => import("../component/Products"));
const QualityPolicy = lazyWithRetry(() => import("../component/QualityPolicy"));
const AboutUs = lazyWithRetry(() => import("../component/AboutUs"));
const TeamMembers = lazyWithRetry(() => import("../component/TeamMembers"));
const Practices = lazyWithRetry(() => import("../component/Practices"));
const Contact = lazyWithRetry(() => import("../component/Contact"));
const Footer = lazyWithRetry(() => import("../component/Footer/Footer"));
const Clients = lazyWithRetry(() => import("../component/Clients"));

const LoadingSpinner = () => (
  <div className="loading-fallback">
    <div className="spinner-border text-primary" role="status">
      <span className="visually-hidden">Cargando...</span>
    </div>
  </div>
);

class HomePage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      navItems: [
        { id: 1, idnm: "home", navheading: "Inicio" },
        { id: 2, idnm: "courses", navheading: "Cursos" },
        { id: 3, idnm: "services", navheading: "Servicios" },
        { id: 4, idnm: "products", navheading: "Productos" },
        { id: 5, idnm: "team", navheading: "Personal" },
        { id: 6, idnm: "clients", navheading: "Clientes" },
        { id: 7, idnm: "contact", navheading: "Contacto" },
      ],
      navClass: "nav-sticky",
      fixTop : true,
      showNavCta: false,
    };
  }

  componentDidMount() {
    this.scrollToHash();
    this.observeHeroCtas();
  }

  scrollToHash = (attempts = 0) => {
    const hash = window.location.hash?.replace("#", "");
    if (!hash) return;
    const target = document.getElementById(hash);
    if (target) {
      const navbarHeight = document.querySelector(".navbar-custom")?.offsetHeight || 0;
      const top = target.getBoundingClientRect().top + window.pageYOffset - navbarHeight;
      window.scrollTo({ top, behavior: "smooth" });
      return;
    }
    if (attempts < 20) {
      window.setTimeout(() => this.scrollToHash(attempts + 1), 150);
    }
  };

  observeHeroCtas = () => {
    const heroCtas = document.getElementById("home-cta");
    if (!heroCtas) {
      this.setState({ showNavCta: true });
      return;
    }

    const navbarHeight =
      document.querySelector(".navbar-custom")?.offsetHeight || 70;

    this.heroCtaObserver = new IntersectionObserver(
      ([entry]) => {
        this.setState({ showNavCta: !entry.isIntersecting });
      },
      {
        threshold: 0,
        rootMargin: `-${navbarHeight}px 0px 0px 0px`,
      }
    );

    this.heroCtaObserver.observe(heroCtas);
  };

  componentWillUnmount() {
    if (this.heroCtaObserver) {
      this.heroCtaObserver.disconnect();
    }
  }

  render() {
    return (
      <>
          <a href="#home" className="skip-link">Saltar al contenido</a>
          <Navbar
            navItems={this.state.navItems}
            navClass={this.state.navClass}
            top={this.state.fixTop}
            showNavCta={this.state.showNavCta}
          />

          <Section />
          <Overview />

          <Suspense fallback={<LoadingSpinner />}>
            <Courses />
            <Services />
            <Products />
            <AboutUs />
            <TeamMembers />
            <QualityPolicy />
            <Practices />
            <Clients />
            <Contact />
            <Footer />
          </Suspense>
      </>
    );
  }
}
export default HomePage;
  